<!-- eslint-disable -->
<template>
  <div id="center">
    <div class="rv_container">
      <template v-for="(item, i) of response">
        <CreateSetFeedComponent
          v-if="item === 'create-set'"
          :key="'create-set'"
          @navigate="navigate"
        />
        <MainFeedItemComponent
          v-else
          ref="grid"
          :key="item.id + '' + i"
          :entity-id="item.id + ''"
          @navigate="navigate"
          :parent-component-data="item.componentData"
        />
      </template>
      <div class="mfi_placeholder" v-if="loading" v-for="(item, index) in placeholderGridData" :key="item">
        <div class="mfi_top">
          <div class="mfi_store_name animated-background">
            <span class="animated-background pointer"></span><br>
            <span class="store_name"></span>
          </div>
          <span class="mfi_created_at animated-background"></span>
        </div>
        <div class="slider animated-background">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AbstractComponent from './AbstractComponent'
import utils from '~/mixins/utils'
import MainFeedItemComponent from '~/components/MainFeedItemComponent'
import CreateSetFeedComponent from '~/components/CreateSetFeedComponent'

export default {
  name: 'ListComponent',
  components: { CreateSetFeedComponent, MainFeedItemComponent },
  extends: AbstractComponent,
  mixins: [utils],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    onByItClick: {
      type: Function
    },
    homeFilterParams: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      skipCounter: 0,
      limit: 0,
      placeholderGridData: [1],
      loading: true,
      noMoreScroll: false,
      response: []
    }
  },
  watch: {
    homeFilterParams (newVal, oldVal) {
      let param = {}
      switch (newVal.type) {
        case 'priceFilter':
          if (newVal && newVal.filter) {
            param = { fromPrice: newVal.filter.fromPrice }
            if (newVal.filter.toPrice) {
              param.toPrice = newVal.filter.toPrice
            }
          } else {
            delete this.componentData.stream.fromPrice
            delete this.componentData.stream.toPrice
          }
          break
        case 'genderFilter': {
          if (newVal && newVal.filter) {
            param = { gender: newVal.filter }
          } else {
            delete this.componentData.stream.gender
          }
          break
        }
        case 'homeGenderFilter': {
          if (newVal && newVal.gender) {
            param = { gender: newVal.gender }
          } else {
            delete this.componentData.stream.gender
          }
          break
        }
        case 'filter': {
          if (newVal && newVal.filter) {
            param = { orderBy: newVal.filter.filter }
          } else {
            delete this.componentData.stream.orderBy
          }
          break
        }
        default:
          Object.keys(newVal).forEach((key) => {
            this.componentData.stream[key] = newVal[key]
          })
          break
      }
      this.componentData.stream = { ...this.componentData.stream, ...param }
      // console.log('this.componentData.stream', this.componentData.stream)
      this.onHomeParamsReady()
    }
  },
  mounted () {
    this.scroll()
    if (this.homeFilterParams) {
      this.onHomeParamsReady()
    }
  },
  methods: {
    onHomeParamsReady () {
      if (this.$store.state.api.cache[window.location.href]) {
        const cache = this.$store.state.api.cache[window.location.href]
        this.componentData.stream = cache.stream
        this.skipCounter = cache.skipCounter
        this.limit = this.componentData.stream.limit
        this.response = cache.data
        setTimeout(() => {
          document.documentElement.scrollTop = cache.scrollTop
        }, 400)
        setTimeout(() => {
          document.documentElement.scrollTop = cache.scrollTop
        }, 700)
        this.$store.commit('api/deleteCache', {
          key: window.location.href
        })
        /* this.$store.commit('api/storeEntities', {
            key: window.location.href,
            stream: this.componentData.stream,
            data: this.response,
            date: new Date()
          }) */
        this.loading = false
      } else {
        this.response = []
        if (this.response.length > 0) {
          this.loading = false
        }
        this.loading = true
        this.noMoreScroll = false
        this.componentData.stream.cache = false
        // this.componentData.stream.saveToLocalStorage = true
        this.componentData.stream.skip = 0
        this.componentData.stream.limit = 2
        this.componentData.stream.includeStories = false
        this.$store.dispatch('api/genericCall', this.componentData.stream).then((response) => {
          this.componentData.stream.skip = 2
          this.componentData.stream.limit = 20
          const modulu = this.componentData.components.length
          response = response.splice(0)
          response.forEach((itm, index) => {
            if (!itm.componentData) {
              itm.templateType = this.componentData.components[index % modulu].type
              itm.componentData = this.componentData.components[index % modulu]
            }
          })
          this.limit = this.componentData.stream.limit
          this.addItemDetailsToEventsLayerMultipleItems('main_feed_first_items', 'view_item_list', response)
          this.response = response
          delete this.componentData.stream.sessionToken
          this.$store.commit('localStorage/storeListResults', {
            key: JSON.stringify(this.componentData.stream),
            data: this.response
          })
          this.loading = false
          this.fetchNextPage()
        }).catch()
      }
    },
    navigate (path) {
      this.$store.commit('api/storeEntities', {
        key: window.location.href,
        stream: this.componentData.stream,
        skipCounter: this.skipCounter,
        data: this.response,
        scrollTop: document.documentElement.scrollTop,
        date: new Date()
      })
      this.$router.push({
        path
      })
    },
    scroll () {
      window.onscroll = () => {
        if (this.noMoreScroll || !this.$refs.grid) {
          return
        }
        const lastGridElement = this.$refs.grid[this.$refs.grid.length - 1]
        if (lastGridElement) {
          const bottomOfWindow = lastGridElement.$el.offsetTop - (document.documentElement.scrollTop + lastGridElement.$el.offsetHeight * 2) < lastGridElement.$el.offsetHeight
          if (bottomOfWindow && !this.loading) {
            this.loading = true
            this.skipCounter++
            this.componentData.stream.skip = this.limit * this.skipCounter
            this.fetchNextPage()
          }
        }
      }
    },
    fetchNextPage () {
      this.$store.dispatch('api/genericCall', this.componentData.stream).then((response) => {
        response.map((itm) => {
          itm.templateType = this.componentData.components[0].type
          itm.componentData = this.componentData.components[0]
          return itm
        })
        if (response.length === 0) {
          this.noMoreScroll = true
          this.loading = false
        } else {
          if (response.length < this.limit) {
            this.noMoreScroll = true
          }
          this.addItemDetailsToEventsLayerMultipleItems('main_feed_pagination', 'view_item_list', response)
          // console.log('skip counter: ' + this.skipCounter)
          // console.log('this.response.length: ' + this.response.length)
          // console.log('response.length: ' + response.length)
          // console.log('this.componentData.stream: ' + JSON.stringify(this.componentData.stream))
          if ((this.response.length === 2 || this.response.length === 3) && response.length >= 20) {
            response.splice(this.response.length === 2 ? 4 : 3, 0, 'create-set')
            this.$store.dispatch('api/sendLogMessage', 'create_set_added_to_feed').then().catch()
            this.$store.dispatch('api/trackEvent', {
              eventName: 'create_set_added_to_feed',
              params: {
                path: this.$route.path,
                page: 'feed'
              }
            }).then().catch()
          }
          this.response = this.response.concat(response)
          this.loading = false
        }
      }).catch()
    }
  }
}
</script>
<style scoped>

  .main > div {
    flex: 1;
    /*border: 1px solid #eee;*/
  }

  #center {
    /*flex: 2;*/
  }

  .rv_container {
    width: 560px;
    margin: auto;
  }

  .mobile_design .rv_container {
    width: 100%;
  }

  /*asldkfjalsdkfjlk*/

  .header-sidebar h4 {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
  }

  .header-sidebar img {
    width: 90px;
    height: 90px;
  }

  > button {
    margin-left: 10px;
  }

  > button {
    border: 0 solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, .07) !important;
    border-radius: 0 !important;
  }

  .mf_item_properties > div {
    text-align: left;
  }

  .slider {
    height: 400px;
  }

  .mfi_placeholder {
    background-color: white;
    margin-top: 1em;
    padding: 1em;
  }
</style>
<!--
"{"filter":"ALL","endpoint":"/items/select","gender":true,"limit":20,"includeComments":true,"includeProperties":true,"mainFeed":true,"sessionToken":"fc9108b5-18f2-4971-98d6-72bcd0a2abbb"}"

-->
